import { Controller } from "@hotwired/stimulus"

const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"]
const MAX_SIZE = 5 * 1024 * 1024

export default class extends Controller {
  static targets = ["image", "fileInput", "removeBtn"]
  static values = { defaultUrl: String }

  selectFile() {
    this.fileInputTarget.click()
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (!file) return

    if (!ALLOWED_TYPES.includes(file.type)) {
      this.showToast(this.t("invalid_type"), "error")
      event.target.value = ""
      return
    }

    if (file.size > MAX_SIZE) {
      this.showToast(this.t("file_too_large"), "error")
      event.target.value = ""
      return
    }

    // Instant preview
    const previousSrc = this.imageTarget.src
    this.imageTarget.src = URL.createObjectURL(file)

    this.uploadAvatar(file, previousSrc)
    event.target.value = ""
  }

  removeAvatar() {
    const previousSrc = this.imageTarget.src

    fetch("/avatar", {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "application/json"
      }
    })
      .then(response => {
        if (!response.ok) throw response
        return response.json()
      })
      .then(data => {
        this.imageTarget.src = data.avatar_url
        this.removeBtnTarget.hidden = true
        this.showToast(this.t("removed"), "success")
      })
      .catch(() => {
        this.imageTarget.src = previousSrc
        this.showToast(this.t("upload_failed"), "error")
      })
  }

  // --- Private ---

  uploadAvatar(file, previousSrc) {
    const formData = new FormData()
    formData.append("avatar", file)

    fetch("/avatar", {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrfToken,
        "Accept": "application/json"
      },
      body: formData
    })
      .then(response => {
        if (!response.ok) throw response
        return response.json()
      })
      .then(data => {
        this.imageTarget.src = data.avatar_url
        this.removeBtnTarget.hidden = false
        this.showToast(this.t("updated"), "success")
        this.updateNavAvatar(data.avatar_url)
      })
      .catch(() => {
        this.imageTarget.src = previousSrc
        this.showToast(this.t("upload_failed"), "error")
      })
  }

  updateNavAvatar(url) {
    const navAvatar = document.querySelector(".dashboard-avatar")
    if (navAvatar) navAvatar.src = url
  }

  t(key) {
    const translations = JSON.parse(this.element.dataset.avatarUploadTranslationsValue || "{}")
    return translations[key] || key
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  showToast(message, type = "error") {
    document.querySelector(".toast[data-source='avatar-upload']")?.remove()

    const toast = document.createElement("div")
    toast.className = `toast toast-${type}`
    toast.setAttribute("data-controller", "toast")
    toast.setAttribute("data-source", "avatar-upload")
    toast.innerHTML = `
      <span>${this.escapeHtml(message)}</span>
      <button class="toast-close" data-action="toast#dismiss">&times;</button>
    `
    document.body.appendChild(toast)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
